import { ReportScene, reportScene } from "../services/DataReporter";
import { UploadFileInfo } from "../store/types";

interface ExtraData {
  fileId: string;
}
export interface UploadResponse extends ExtraData {
  fileId: string;
  filePath: string;
  fileType: string;
  sourceFileName: string;
}

const isEnv = process.env.NODE_ENV === "development";
const fileBaseUrl = isEnv
  ? "/hub/gateway/csm"
  : process.env.NEXT_PUBLIC_API_HUB_HOST;

export async function fileUploadApi({
  file,
  fileId,
  onError,
  onSuccess,
}: {
  file: File;
  fileId: string;
  onError: (fileId: string, fileInfo: UploadFileInfo) => void;
  onSuccess: (data: UploadResponse) => void;
}) {
  const uploadFileUrl = `${fileBaseUrl}/file/fileRecord/csm/uploadWithName?systemCode=CSM&bizCode=csm_private&dir=im`;
  try {
    const formData = new FormData();
    formData.append("file", file);
    reportScene(
      ReportScene.UPLOAD_FILE,
      JSON.stringify({
        fileName: file.name,
        fileId,
        status: "start",
      }),
    );
    const response = await fetch(uploadFileUrl, {
      method: "POST",
      body: formData,
    });
    if (!response.ok) {
      onError(fileId, { file, fileId });
      reportScene(
        ReportScene.API_ERROR,
        JSON.stringify({
          url: uploadFileUrl,
          file: file.name,
          originFileId: fileId,
          status: response.status,
          statusText: response.statusText,
          headers: [...response.headers?.entries()],
          userAgent:
            typeof navigator !== "undefined" ? navigator.userAgent : "",
        }),
      );
      return;
    }
    const data = await response.json();
    if (data.code === "000000") {
      onSuccess({
        ...data.data,
        fileId,
      });
      reportScene(
        ReportScene.UPLOAD_FILE,
        JSON.stringify({
          originFileId: fileId,
          status: "success",
        }),
      );
    } else {
      reportScene(
        ReportScene.UPLOAD_FILE,
        JSON.stringify({
          originFileId: fileId,
          code: data.code,
          status: "error code",
        }),
      );
      onError(fileId, { file, fileId });
    }
  } catch (error) {
    onError(fileId, { file, fileId });
    // 处理不同类型的错误
    let errorInfo: any;
    if (error instanceof TypeError && error.message === "Failed to fetch") {
      // 特别处理网络错误
      errorInfo = {
        name: error.name,
        message: error.message,
        type: "network_error",
        description: "Request was blocked or network failure occurred",
      };
    } else if (error instanceof Error) {
      // 标准错误处理
      errorInfo = {
        name: error.name,
        message: error.message,
        stack: error.stack,
        ...Object.getOwnPropertyNames(error).reduce(
          (acc: Record<string, any>, key: string) => {
            acc[key] = (error as any)[key];
            return acc;
          },
          {},
        ),
      };
    } else {
      // 非Error对象
      errorInfo = error;
    }
    reportScene(
      ReportScene.API_ERROR,
      JSON.stringify({
        originFileId: fileId,
        error: errorInfo,
        userAgent: typeof navigator !== "undefined" ? navigator.userAgent : "",
      }),
    );
  } finally {
  }
}
